import { render, staticRenderFns } from "./MVMTag.vue?vue&type=template&id=0944c409&"
import script from "./MVMTag.vue?vue&type=script&lang=js&"
export * from "./MVMTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports